import { ConfigProvider, Spin, SpinProps } from "antd";
import React from "react";

type Props = SpinProps & {
  color?: string;
};

function ButtonLoader({
  size,
  spinning = true,
  color = "#1677ff",
  ...rest
}: Props) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: color,
        },
      }}
    >
      <Spin spinning={spinning} {...rest} />
    </ConfigProvider>
  );
}

export default ButtonLoader;
